var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPpwebSocialTiktok = function SvgPpwebSocialTiktok(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.382 0H8.685v10.899c0 1.298-1.037 2.365-2.328 2.365S4.03 12.197 4.03 10.899c0-1.276 1.014-2.32 2.258-2.366V5.797c-2.742.046-4.955 2.296-4.955 5.102C1.333 13.728 3.592 16 6.381 16c2.788 0 5.047-2.296 5.047-5.101V5.31A6.24 6.24 0 0 0 15 6.516V3.78c-2.028-.07-3.618-1.74-3.618-3.78"
  })));
};
export default SvgPpwebSocialTiktok;